<tile
    title="{{ 'keywords_top_50' | translate }}"
    icon="trophy"
    change="{{keywordsTop50ChangePercentage}}"
    [showChange]="showChange"
    val="{{ keywordsTop50 | undefinedNumber }}">
</tile>
